
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import _ from 'lodash';
import { rejectInvestigationReasons } from 'src/app/shared/helpers/helper';
@Component({
  selector: 'app-cancelled-reason-multiselect-kendo',
  templateUrl: './cancelled-reason-multiselect-kendo.component.html',
  styleUrls: ['./cancelled-reason-multiselect-kendo.component.scss']
})
export class CancelledReasonMultiselectKendoComponent implements OnInit, OnChanges {

  @Input() placeholder = "Select a reason(s)";
  @Input() label = "Reason";
  @Input() disabled = false;
  @Input() selectedId: Array<string> = [];

  @Output() selectionChanged = new EventEmitter<string[] | null>();
  @Output() enteredPressed = new EventEmitter<Number>();

  public selectedValue = [];
  public cancelledReasons = rejectInvestigationReasons;
  constructor() {}

  ngOnInit(): void {
    if (!this.selectedId || this.selectedId?.length === 0) {
      this.selectedValue = [];
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (!_.isEqualWith(this.selectedValue, changes?.selectedId?.currentValue)) {
      this.selectedId = changes?.selectedId?.currentValue || [];
        if (this.selectedId?.length) {
          this.selectedValue = this.selectedId
        } else {
          this.selectedValue = [];
        }
    }
  }

  public searchSelect($event) {
    this.selectedId = $event;
    this.selectionChanged.emit(this.selectedId);
  }

  public tagMapper(tags: any[]): any[] {
    return tags.length < 1 ? tags : [tags];
  }

  public onEnterPress() {
    this.enteredPressed.emit(Math.random());
  }

}
